<template>
  <section class="legal-services-info-section  container">
    <div class="legal-services-info-section__content  container-inner">
      <div class="legal-services-info-section__img-wrap">
        <picture class="legal-services-info-section__img">
          <source v-if="section.image_xs_webp"
                  :srcset="section.image_xs_webp"
                  type="image/webp"
                  :media="`(max-width: ${WINDOW_SIZE_XS}px)`">
          <source v-if="section.image_xs"
                  :srcset="section.image_xs"
                  :media="`(max-width: ${WINDOW_SIZE_XS}px)`">

          <source v-if="section.image_sm_webp"
                  :srcset="section.image_sm_webp"
                  type="image/webp"
                  :media="`(max-width: ${WINDOW_SIZE_SM}px)`">
          <source v-if="section.image_sm"
                  :srcset="section.image_sm"
                  :media="`(max-width: ${WINDOW_SIZE_SM}px)`">

          <source v-if="section.image_md_webp"
                  :srcset="section.image_md_webp"
                  type="image/webp"
                  :media="`(max-width: ${WINDOW_SIZE_MD}px)`">
          <source v-if="section.image_md"
                  :srcset="section.image_md"
                  :media="`(max-width: ${WINDOW_SIZE_MD}px)`">

          <source v-if="section.image_lg_webp"
                  :srcset="section.image_lg_webp"
                  type="image/webp"
                  :media="`(max-width: ${WINDOW_SIZE_LG}px)`">
          <source v-if="section.image_lg"
                  :srcset="section.image_lg"
                  :media="`(max-width: ${WINDOW_SIZE_LG}px)`">


          <source v-if="section.image_xl_webp"
                  :srcset="section.image_xl_webp"
                  type="image/webp">
          <img :src="section.image_xl"
               :alt="createAltMixin('')"
               :title="createTitleMixin('')">
        </picture>
      </div>
      <div class="legal-services-info-section__main-wrap">
        <div v-html="section.text"
             class="legal-services-info-section__text text"></div>
        <LegalServicesPageGetHelpBtn :botUrls="botUrls"
                                     class="legal-services-info-section__btn"/>
      </div>
    </div>
  </section>
</template>

<script>
  import {
    WINDOW_SIZE_LG,
    WINDOW_SIZE_MD,
    WINDOW_SIZE_SM,
    WINDOW_SIZE_XS
  } from '@/constants/windowSizes'
  import LegalServicesPageGetHelpBtn from './common/LegalServicesPageGetHelpBtn'

  export default {
    name: 'LegalServicesPageInfoSection',
    components: {
      LegalServicesPageGetHelpBtn
    },
    props: {
      section: Object,
      botUrls: Object
    },
    data() {
      return {
        WINDOW_SIZE_XS,
        WINDOW_SIZE_SM,
        WINDOW_SIZE_MD,
        WINDOW_SIZE_LG
      }
    }
  }
</script>

<style lang="less">

</style>
